import { useReplyDraftsGateway } from './ReplyDraftsGatewayProvider';
import { getReplyDraftsV2QueryOptions } from '../api/queryOptions';

import { useUserScopedQuery } from '@/hooks/useUserScopedQuery';

/** The signed-in expert's open drafts, fetched only where `.draft` could be offered. */
export function useOpenReplyDrafts({ enabled }: { enabled: boolean }) {
  return useUserScopedQuery(getReplyDraftsV2QueryOptions, [useReplyDraftsGateway()], { enabled });
}
